import React from "react";
import styled from "styled-components";
import { formatDateTime } from "../../../utils/dateUtils";
import FullScreenOverlay from "../../common/FullScreenOverlay";
// import Pagination from "../../common/Pagination";

const AuditLogs = ({
  title,
  loading,
  logs,
  onClose,
  // page,
  // total,
  // onPageChange,
}) => {
  // const rowsPerPage = 10;
  // const totalPages = Math.ceil(total / rowsPerPage);

  if (loading) return <div>Loading audit logs…</div>;
  return (
    <FullScreenOverlay
      title={title}
      iconClose
      onClose={onClose}
      width="80%"
      height="80%"
      buttons={[]}
      zIndex={1100}
    >
      <TableWrapper>
        <CarePlanTable>
          <thead>
            <tr>
              <th>Action</th>
              <th>Action By</th>
              <th>Action On</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td>{log.action}</td>
                <td>{log.action_by}</td>
                <td>{formatDateTime(log.action_on)}</td>
              </tr>
            ))}
          </tbody>
        </CarePlanTable>
      </TableWrapper>
      {/* <Pagination
        currentPage={page}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        totalRows={total}
        onPageChange={(newPage) => onPageChange(newPage)}
        onRowsPerPageChange={() => {}}
        hideRowsPerPage={true}
      /> */}
    </FullScreenOverlay>
  );
};

export default AuditLogs;

export const TableTop = styled.div`
  margin-bottom: 24px;
`;

export const TableWrapper = styled.div`
  border-radius: 12px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e9ecef;
  box-shadow: 0px 10px 16px 0px rgba(230, 230, 230, 0.25);
`;

export const CarePlanTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 14px 16px;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  th {
    padding: 16px;
    color: #6c757d;
  }

  th:first-child {
    border-top-left-radius: 12px;
  }

  th:last-child {
    border-top-right-radius: 12px;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 12px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
  }

  td {
    color: #161718;
  }
`;
